import {Component, OnInit, OnDestroy} from '@angular/core';
import {CommonModule} from '@angular/common';
import {
    DashboardKeyMetricsService,
    DashboardUpcomingTask
} from '@services/dashboard-key-metrics.service';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {DialogModule} from 'primeng/dialog';
import {TaskDetailResponse, TaskService} from '@services/task.service';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-upcoming-tasks',
    standalone: true,
    imports: [CommonModule, DialogModule],
    templateUrl: './upcoming-tasks.component.html',
    styleUrl: './upcoming-tasks.component.scss'
})
export class UpcomingTasksComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    constructor(
        private dashboardService: DashboardKeyMetricsService,
        private taskService: TaskService,
        private toastr: ToastrService
    ) {}
    tasks: DashboardUpcomingTask[] = [];
    // View details dialog state
    showViewDialog = false;
    viewTaskData: TaskDetailResponse | null = null;
    loading = false;
    ngOnInit(): void {
        this.dashboardService
            .getDashboardUpcomingTasks()
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (tasks) => {
                    this.tasks = tasks;
                },
                error: () => {
                    this.tasks = [];
                }
            });
    }

    openViewDetails(task: DashboardUpcomingTask) {
        if (!task?.id) return;
        this.loading = true;
        this.taskService.getTaskDetailById(task.id).subscribe({
            next: (details) => {
                this.viewTaskData = details;
                this.showViewDialog = true;
                this.loading = false;
            },
            error: () => {
                this.toastr.error('Failed to load task details');
                this.loading = false;
            }
        });
    }

    closeViewDialog() {
        this.showViewDialog = false;
        this.viewTaskData = null;
    }
    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
